module.exports = __webpack_public_path__ + "static/media/auto2.fbf6d972.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/bcase/assets/auto2.png
// module id = 2560
// module chunks = 0